
var stache = require('can/view/stache/stache');
module.exports = stache("<search-component {unique-module-id}=\"uniqueId\"></search-component>");